import { Outlet } from 'react-router-dom'

import { Auth, Inspector } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'
import Signature from 'Components/FormGroup/Signature'

const inspector = [
    {
        path: 'inspector',
        element: <Auth guard="inspector" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'inspector',
        element: <Inspector guard="inspector" />,
        children: [
            { path: '', element: <Lazy view="Inspector/Dashboard" /> },
            { path: 'profile', element: <Lazy view="Inspector/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            { path: 'signature', element: <Signature /> },

            {
                path: 'tests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Inspector/Tests/List" /> },
                    { path: ':test_id', element: <Lazy view="Inspector/Tests/View" title="View" /> },
                ],
            },
        ],
    },
]

export default inspector
